export enum RequestStoreKey {
  VEHICLE_BRANDS = "request_vehicle_brands",
  VEHICLE_MODELS = "request_vehicle_models"
}
